import React, { useState } from "react";
import styled from "styled-components";
import Chevron from "../../../../../assets/images/icons/Web_Sprite_Icon_Chevron_Grey_analytics.png";

const LinkoutList = ({
    data,
    totalVisit,
    Filter,
    ImageContainer,
    displayDate,
    isLinkoutListModalOpen,
    setIsLinkoutListModalOpen,
}) => {
    const [showAll, setShowAll] = useState(false);
    return (
        <LinkoutListContainer>
            <LinkoutListHeader>
                {!isLinkoutListModalOpen && (
                    <>
                        <LinkoutListTitle>Interaction Clicks</LinkoutListTitle>
                        {/* <Filter mobileWidth={"80%"}>
                            <FilterText>Overall</FilterText>
                            <ImageContainer
                                src={Chevron}
                                width={"16px"}
                                height={"16px"}
                                padding={"2.235px 0px"}
                                alt="chevron"
                                isChevron
                            />
                        </Filter> */}
                    </>
                )}

                {isLinkoutListModalOpen && (
                    <>
                        <PopupDateTitle>{displayDate}</PopupDateTitle>
                        <TotalVisits>
                            Total Visits: <span>{totalVisit.toLocaleString()}</span>
                        </TotalVisits>
                    </>
                )}
            </LinkoutListHeader>

            {(isLinkoutListModalOpen ? data : data.slice(0, 5)).map((item, index) => (
                <ListItem key={index} isOdd={index % 2 === 0}>
                    <Name rank={index}> {`${index + 1}`}</Name>
                    <Name rank={index} style={{ flex: 1 }}>
                        {item.name}
                    </Name>
                    <Visits rank={index}>{item.visits.toLocaleString()}</Visits>
                </ListItem>
            ))}

            {!isLinkoutListModalOpen && (
                <ChartFooter>
                    <TotalVisits>
                        Total Visits: <span>{totalVisit.toLocaleString()}</span>
                    </TotalVisits>
                    <ChartDetailsContainer onClick={() => setIsLinkoutListModalOpen(true)}>
                        <ChartDetailText>View more details</ChartDetailText>
                        <ImageContainer
                            src={Chevron}
                            width={"17px"}
                            height={"17px"}
                            padding={"1.324px 0.294px"}
                            alt="chevron"
                            style={{ rotate: "180deg" }}
                        />
                    </ChartDetailsContainer>
                </ChartFooter>
            )}
        </LinkoutListContainer>
    );
};

export default LinkoutList;

const rankColors = {
    name: ["#FFE664", "#BFD5F9", "#EF9546", "var(--Text-Primary, #fbfcff)"],
    visits: ["#FFE664", "#BFD5F9", "#EF9546", "var(--Text-Secondary, #ced1d9)"],
};

const LinkoutListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

const LinkoutListHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const LinkoutListTitle = styled.div`
    color: var(--Text-Primary, #fbfcff);
    font-family: "Barlow";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
`;

const FilterText = styled.p`
    color: var(--White---Black-White, #fbfcff);
    font-family: "Barlow";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.5px;

    @media (max-width: 768px) {
        flex: 1;
    }
`;

const DataListWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    justify-content: center;
    min-height: 200px;
`;

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 8px;
`;

const ListItem = styled.li`
    display: flex;
    // justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    background-color: ${({ isOdd }) => (isOdd ? "rgba(255, 255, 255, 0.04)" : "transparent")};
    width: 100%;
`;

const Name = styled.span`
    color: ${({ rank }) => rankColors.name[rank] || rankColors.name[3]};
    font-family: "Barlow";
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    text-transform: capitalize;
    line-height: normal;
    padding-left: 20px;
`;

const Visits = styled.span`
    color: ${({ rank }) => rankColors.visits[rank] || rankColors.visits[3]};
    font-family: "Barlow";
    font-size: 17px;
    font-style: normal;
    font-weight: 700;
    text-transform: capitalize;
    line-height: normal;
    padding-right: 20px;
`;

const TotalVisits = styled.div`
    color: var(--Text-Secondary, #ced1d9);
    text-align: right;
    font-family: "Barlow";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    span {
        color: var(--Text-Primary, #fbfcff);
        font-family: "Barlow";
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
`;

const ChartFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    margin-top: 25px;
`;

const ChartDetailsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
`;

const ChartDetailText = styled.div`
    color: var(--Purple-Secondary, #9d75f5);
    text-align: right;
    font-family: "Barlow";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const PopupDateTitle = styled.p`
    color: var(--White---Black-Light-Grey, #9d9d9d);
    leading-trim: both;
    text-edge: cap;
    font-family: "Barlow";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 1.8px;
    text-transform: uppercase;
`;

const ModalHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px; /* space between title and visits */
`;

const LegendHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 25px;
`;

const HeaderText = styled.div`
    color: var(--Text-Secondary, #ced1d9);
    font-family: "Barlow";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
`;
